import React from 'react'
import { useTheme } from '../../../../components/mui/Styles/index'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import { Box, Card, CardContent, Typography } from '../../../../components/mui/Core/index'
import Constants from '../../../../constants/en.json'

function ResetPasswordSent() {
  const theme = useTheme()
  return (
    <Box sx={theme.soloContainer}>
      <Card className='soloCard'>
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <FormHeading formHeader='Password Reset Request Sent' />
            <Typography variant='body1' sx={{ textAlign: 'center' }}>
              {Constants.forgotPassword.RESET_PASSWORD_LINK_MESSAGE}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ResetPasswordSent
